var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-fade-in"}},[(_vm.visible)?_c('div',{staticClass:"c-toporbottom",style:({
            right: _vm.styleRight,
            bottom: _vm.styleBottom,
            zIndex: _vm.zIndex,
        })},[_c('div',{staticClass:"c-toporbottom-top",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"el-icon-caret-top"})]),_c('div',{staticClass:"c-toporbottom-bottom",on:{"click":_vm.scrollToBottom}},[_c('i',{staticClass:"el-icon-caret-bottom"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }